import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d87943b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app__loader-frame"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"app__loader\" data-v-1d87943b><div class=\"container-fluid g-0 app__loader-container\" data-v-1d87943b><div class=\"row app__loader-imagecontainer\" data-v-1d87943b><div class=\"col\" data-v-1d87943b><img src=\"img/icons/loader.gif\" class=\"app__loader-image\" alt=\"\" data-v-1d87943b></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.LoaderParameter.isInProgress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["app__loader_blur", _ctx.sizing])
        }, _hoisted_3, 2)
      ]))
    : _createCommentVNode("", true)
}